import React from 'react';
import { getDisplayName } from 'shared/helpers/common';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStatsEvents from 'shared/hocs/stats/withStatsEvents';
import { adWordsSendAdvertPageView } from 'shared/helpers/adwordsEvents';
import { setDataLayer } from 'shared/actions/globals';
import { sendAdvertViewEvent } from '../../helpers/gtmEvents';

const mapStateToProps = ({ user }) => ({ userID: user.user.id });

const withAdvertViewEvent = WrappedComponent =>
  connect(mapStateToProps, { setDataLayer })(
    withStatsEvents(
      class extends React.Component {
        static displayName = `withAdvertViewEvent(${getDisplayName(WrappedComponent)})`;

        static propTypes = {
          setDataLayer: PropTypes.func.isRequired,
          events: PropTypes.shape({
            dispatchAdvertViewEvent: PropTypes.func,
          }).isRequired,
          advertInfo: PropTypes.shape({
            id: PropTypes.number,
            author: PropTypes.shape({
              id: PropTypes.number,
            }),
            price: PropTypes.arrayOf(PropTypes.shape()),
          }).isRequired,
          isSpare: PropTypes.bool,
        };
        static defaultProps = {
          isSpare: false,
        };

        componentDidMount() {
          const { events, advertInfo, isSpare } = this.props;

          const transport = isSpare ? advertInfo.vehicle_type : advertInfo.transport;
          const transportId = transport && transport.id;
          const agency = advertInfo.agency;
          const agencyId = agency && agency.id;

          events.dispatchAdvertViewEvent(
            advertInfo.id,
            advertInfo.author.id,
            transportId,
            agencyId,
            isSpare,
          );

          if (!isSpare) {
            sendAdvertViewEvent(advertInfo, null, this.props.setDataLayer);
            adWordsSendAdvertPageView(advertInfo, this.props.setDataLayer);
          }
        }

        render() {
          const { events, ...props } = this.props;

          return <WrappedComponent {...props} />;
        }
      },
    ),
  );

export default withAdvertViewEvent;



// WEBPACK FOOTER //
// ./src/shared/hocs/stats/withAdvertViewEvent.js